import { useState, useEffect } from "react";
import { supabase } from '../utils/supabaseClient';

/**
 * Controls teachers.telegram_notifications_enabled — read by
 * supabase/functions/telegram-webhook/index.ts before relaying a student's
 * chat message into the teacher's Telegram. Turning this off only stops
 * that relay; the message still lands in the in-app chat either way.
 */
export function useTelegramNotifications({ showSavedToast }) {
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data: { user: authUser } } = await supabase.auth.getUser();
      if (!authUser) { setLoading(false); return; }
      const { data, error } = await supabase
        .from('teachers')
        .select('telegram_notifications_enabled')
        .eq('auth_user_id', authUser.id)
        .maybeSingle();
      if (!cancelled) {
        if (!error && data) setEnabled(data.telegram_notifications_enabled !== false);
        setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const toggle = async () => {
    const next = !enabled;
    setEnabled(next); // optimistic
    try {
      const { data: { user: authUser } } = await supabase.auth.getUser();
      if (!authUser) return;
      const { error } = await supabase
        .from('teachers')
        .update({ telegram_notifications_enabled: next })
        .eq('auth_user_id', authUser.id);
      if (error) {
        setEnabled(!next); // revert on failure
        return;
      }
      showSavedToast?.();
    } catch {
      setEnabled(!next);
    }
  };

  return { enabled, loading, toggle };
}
